export default __webpack_public_path__ + "static/media/p67.40e1c058.jpg";